import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";

export type FirmReferralDirectoryEntry = {
  firmId: string;
  name: string;
  email: string | null;
  phoneNumber: string | null;
  practiceAreas: { id: string; label: string; description?: string | null }[];
  serviceAreas: string[];
};
export type FirmReferralRelationshipStatus =
  | "none"
  | "incoming"
  | "outgoing"
  | "partner";
export type FirmReferralDirectorySearchEntry = FirmReferralDirectoryEntry & {
  relationshipStatus: FirmReferralRelationshipStatus;
  requestId: string | null;
};
export type FirmReferralProfile = FirmReferralDirectoryEntry & {
  published: boolean;
  dateCreated: string;
  dateModified: string;
};
export type UpdateReferralProfileInput = {
  dateModified: string;
} & Partial<{
  email: string | null;
  phoneNumber: string | null;
  practiceAreaIds: string[];
  serviceAreas: string[];
}>;
export type ReferralDirectoryFilters = {
  search?: string;
  practiceAreaIds?: string[];
  serviceAreas?: string[];
};
export const retrieveReferralProfile = () =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<FirmReferralProfile>>("/firms/v2/referral-profile")
    .then((res) => res.data);
export const updateReferralProfile = (input: UpdateReferralProfileInput) =>
  authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<FirmReferralProfile>
    >("/firms/v2/referral-profile", input)
    .then((res) => res.data);
export const searchReferralProfiles = (
  filters: ReferralDirectoryFilters,
  cursor?: string,
) =>
  authenticatedFastApiAxiosInstance
    .post<APIResponse<FirmReferralDirectorySearchEntry[]>>(
      "/firms/v2/referral-profiles/search",
      filters,
      {
        params: { cursor, limit: 24 },
      },
    )
    .then((res) => res.data);
